import { ValidTagularPayload } from '../types/Tagular';
import { EventMap, EventName } from '../constants/tagular/events';

// eslint-disable-next-line no-unused-vars, no-shadow
type APIHandler = (method: string, ...args: any[]) => (...args: any[]) => void;

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    tagular?: APIHandler;
  }
}

/**
 * Submit ('beam') an even via Tagular to Make
 * @param eventName Schema Name of the Event
 * @param eventData The data required by the schema
 */
const tagularEvent = (eventName: EventName, eventData: ValidTagularPayload) => {
  // if tagular is available, try sending given event with event data
  if ('tagular' in window && window.tagular) {
    try {
      window.tagular('beam', eventName, {
        '@type': EventMap[eventName],
        ...eventData,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(`Tagular event ${eventName} not sent.`, error);
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn('Tagular not available on page.');
  }
};

export default tagularEvent;
